/*
 * rheincool — Filter-Alias-Übersetzung (Umsetzungsplan 1.2)
 * Ratgeber-CTAs verlinken sprechende Parameter (?leistung=2-5-kw&heizfunktion=ja).
 * Dieses Modul liest die zentrale Tabelle (#rc-filter-aliases), übersetzt sie
 * in Search-&-Discovery-Parameter und lädt die gefilterte Ansicht via
 * history.replaceState + rc-facets-page. Unbekannte Parameter bleiben unberührt.
 */
(() => {
  'use strict';

  const configEl = document.getElementById('rc-filter-aliases');
  const page = document.querySelector('rc-facets-page');
  if (!configEl || !page) return;

  let aliases;
  try {
    aliases = JSON.parse(configEl.textContent);
  } catch (error) {
    console.warn('[rc-filter-alias] Konfiguration unlesbar', error);
    return;
  }

  const current = new URLSearchParams(window.location.search);
  const translated = new URLSearchParams();
  let found = false;

  current.forEach((value, key) => {
    const alias = aliases[key];
    if (!alias) {
      translated.append(key, value);
      return;
    }
    found = true;

    if (alias.values === 'passthrough') {
      translated.append(alias.param, value);
      return;
    }
    const mapping = alias.values[value];
    if (!mapping) return;

    if (mapping.gte !== undefined) translated.append(`${alias.param}.gte`, mapping.gte);
    if (mapping.lte !== undefined) translated.append(`${alias.param}.lte`, mapping.lte);
    if (mapping.eq !== undefined) {
      const values = Array.isArray(mapping.eq) ? mapping.eq : [mapping.eq];
      values.forEach((v) => translated.append(alias.param, v));
    }
  });

  if (!found) return;

  const target = `${window.location.pathname}?${translated.toString()}`;
  // Sprechende URL in der Adresszeile lassen wäre schöner, aber die
  // Section-Rendering-Antwort braucht die echten Filter-Parameter — daher
  // einmalig ersetzen; Canonical zeigt ohnehin auf die Filter-URL (SEO §13).
  if (typeof customElements !== 'undefined') {
    customElements.whenDefined('rc-facets-page').then(() => page.load(target));
  }
})();
